export default class RoutePath {
  // User Management
  public static usersGroups: string = "/usersandgroups";

  // Nested Routes for User Management
  public static allUsers: string = "all-users";
  public static deletedUsers: string = "deleted-users";
  public static userLogs: string = "user-logs";
  public static allGroups: string = "all-groups";
  public static deletedGroups: string = "deleted-groups";
  public static userDetails: string = "user-details";

  // Other Views and Forms
  public static organizations: string = "/";
  public static reports: string = "/reports";
  public static symetrireports: string = "/symetri-reports";
  public static users: string = "/users";
  // Private Constructor to block instancing to emulate a C# Static class
  private constructor() {}
}
